export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";
export const API_URL = `${BACKEND_URL}/api`;
